import { render, staticRenderFns } from "./jt808-sendcmd.vue?vue&type=template&id=67d7c3e9&scoped=true"
import script from "./jt808-sendcmd.vue?vue&type=script&lang=js"
export * from "./jt808-sendcmd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7c3e9",
  null
  
)

export default component.exports